// Italian — top-level translations. i18next falls back to English for missing keys.
import en from "./en";

const it = {
  ...en,
  ui: {
    ...en.ui,
    brand: "My World Quest",
    brand_subtitle: "Colora e Impara",
    nav: {
      home: "Casa", countries: "Paesi", globe: "Globo", continents: "Continenti",
      color: "Colora", puzzles: "Puzzle", games: "Giochi", math: "Geo Matematica",
      quiz: "Quiz", parents: "Genitori", more: "Altro",
     "geo-lines": "Linee del mondo", "maths-academy": "Accademia di Matematica",},
    accessibility: { bigText: "Testo Grande", highContrast: "Alto Contrasto" },
    navGroups: { quick: "Veloce", explore: "Esplora", play: "Gioca e impara", collect: "Colleziona", adv: "Avventura", grownup: "Per gli adulti" },
    actions: { back: "Indietro", close: "Chiudi", reset: "Ripristina", save: "Salva", retry: "Riprova", playAgain: "Gioca Ancora" },
  },
  microcopy: {
    ...en.microcopy,
    great: "Ottimo lavoro! ⭐",
    correct: "✅ Esatto!",
    nope: "Riprova!",
    tryAgain: "Quasi. Continua!",
    awesome: "Fantastico!",
    welcome: "Benvenuto in {{country}}! Impariamo {{language}}.",
    youDidIt: "Ce l'hai fatta!",
    perfect: "PERFETTO!",
  },
  home: {
    ...en.home,
    title1: "Esplora il Mondo",
    title2: "Un Paese alla Volta",
    subtitle: "Divertenti avventure geografiche, quiz, sfide e premi che aiutano i bambini a scoprire paesi, culture, bandiere, monumenti e molto altro.",
    playNow: "Gioca Ora →",
    takeQuiz: "Fai un Quiz",
    openGlobe: "Apri il Globo Grande →",
    globeHint: "Tocca un punto luminoso per imparare un paese!",
    popularCountries: "O tocca una bandiera",
    whatNext: "Cosa vuoi fare oggi?",
    whatNextSub: "Scegli quello che vuoi — è tutto divertente!",
    tiles: {
      ...en.home.tiles,
      learn: "Impara i Paesi", learnDesc: "30+ paesi con bandiere!",
      globe: "Globo 3D", globeDesc: "Gira e tocca per esplorare",
      continents: "Continenti", continentsDesc: "Esplora i 7 continenti",
      color: "Colora Monumenti", colorDesc: "Colora la Torre Eiffel!",
      math: "Matematica Geografica", mathDesc: "Somma km, conta paesi!",
      quiz: "Quiz Time", quizDesc: "Quiz base e avanzato",
      parents: "Per i Genitori", parentsDesc: "Vedi i progressi",
    },
  },
  learn: {
    title: "Impara i Paesi", capital: "Capitale", language: "Lingua", hello: "Ciao",
    learnIt: "L'ho imparato!", listen: "Ascolta",
    goalsEyebrow: "Obiettivi di Apprendimento di Oggi",
    goalsHeading: "🎯 Concentrati prima su questi",
    goalsSubtitle: "Le quattro cose più importanti da imparare a {{tier}} anni — scelte dal programma.",
    goalsAllTopics: "Vedi tutti gli argomenti",
    goalsLearnNow: "Impara ora",
    goalsKey: "Chiave n°{{n}}",
    topicTitles: {
      "art-design": "Disegno, Pittura e Design",
      "music": "Musica: Ritmo, Canto e Notazione",
      "computing-code": "Coding, Algoritmi e Sicurezza Online",
      "physical-education": "Ed. Fisica, Salute e Fitness",
      "world-religions": "Religioni e Credenze del Mondo",
      "wellbeing-relationships": "Salute, Emozioni e Amicizie",
    },
  },
  globe: {
    title: "Globo 3D", subtitle: "Gira e tocca per esplorare",
    learnLang: "Impara la lingua", moreInfo: "Altre informazioni", learnedTag: "✓ Imparato",
    spinTap: "Gira il globo e tocca un paese!", spinTapSub: "Tocca uno spillo per saperne di più.",
  },
  quiz: {
    title: "Quiz Time", basic: "Base", advanced: "Avanzato",
    start: "Inizia Quiz", next: "Avanti →", finish: "Finito!", score: "Punteggio",
  },
  stickers: { title: "Il mio Album di Sticker", subtitle: "Colleziona uno sticker da ogni attività!" },
  langSwitcher: {
    label: "Lingua",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية",
    italian: "Italiano", spanish: "Español", mandarin: "中文", japanese: "日本語", korean: "한국어", swahili: "Kiswahili",
  },
  common: {
    whereToNext: "Dove andiamo ora?",
    home: "Casa",
    earnMoreStars: "⭐ Ottieni più stelle",
    earnHowTo: "Gioca a un gioco veloce — ognuno ti dà XP!",
    pickAge: "Scegli età",
    ages: "Età",
    startExploring: "Inizia a esplorare",
    pickAnywhere: "Scegli qui sopra — o clicca!",
    tapAnyCountry: "Tocca un paese per scoprirne la storia!",
    exploreGlobe: "Esplora il Globo",
    exploreGlobeSub: "Avventura 3D a schermo intero",
  },
  shortcuts: {
    home: "Home",
    continents: "Continenti",
    globe: "Globo",
    ask: "Chiedi",
    landmarks: "Monumenti",
    flags: "Bandiere",
    pixel: "Pixel",
    puzzles: "Puzzle",
    math: "Matematica",
    trip: "Viaggio",
    quiz: "Quiz",
    quests: "Missioni",
    stickers: "Adesivi",
    miniGames: "Mini-giochi",
    geoMath: "Geo-Matematica",
    quickQuiz: "Quiz Veloce",
    myTrophies: "I miei trofei",
    colorCreate: "Colora e Crea",
    spinGlobe: "Fai girare il globo",
    askGlobe: "Chiedi al globo",
    dreamTrip: "Viaggio dei Sogni",
    earnStars: "Guadagna stelle",
    tryAQuest: "Prova una missione",
    playAgain: "Gioca ancora",
    learnCountry: "Impara un paese",
    colorLandmark: "Colora un monumento",
    learnCountries: "Impara i Paesi",
    advanced: "Modalità Avanzata",
    spellCountry: "Indovina un paese",
    advancedHub: "Zona avanzata",
    squishyHop: "Squishy Hop",
    mathSnap: "Math Snap",
    language: "Lingua",
    geoLines: "Linee del mondo",
  },
  coloringExtra: {
    modeLandmarks: "Monumenti",
    modeFlags: "Artista delle Bandiere",
    modePixel: "Pixel Art",
    diffEasy: "Facile",
    diffMedium: "Medio",
    diffExpert: "Esperto",
    difficultyLabel: "Difficoltà:",
  },
  tilesExtra: {
    labelLearn: "Impara",
    labelCreate: "Crea",
    labelPlay: "Gioca",
    labelTrophies: "Trofei",
    whatNextSub: "Scegli quel che vuoi — è tutto divertente!",
  },
  pills: {
    orTry: "O prova ↓",
    
    squishyHop: "Squishy Hop",
    mathSnap: "Snap matematico",colorLandmark: "Colora un monumento",
    solvePuzzle: "Risolvi un puzzle",
    dreamTrip: "Pianifica un viaggio",
    geoMath: "Prova geo-matematica",
    continentQuests: "Missioni per continente",
    stickerBook: "Album di adesivi",
    famousPeople: "Persone famose",
    culturalSpot: "Spot culturale",
    quickQuiz: "Quiz veloce",
    continentMaps: "Mappe continenti",
    spellCountry: "Indovina un paese",
    flagArtist: "Artista delle bandiere",
    pixelArt: "Pixel art",
    spinGlobe: "Fai girare il globo",
    askGlobe: "Chiedi al globo",
    myTrophies: "I miei trofei",
    advancedHub: "Zona avanzata",
    geoLines: "Linee del mondo",
  },
  canvas: {
    tools: "Strumenti",
    brushSize: "Pennello",
    colors: "Colori",
    patterns: "Motivi",
    modes: "Modalità",
    solid: "Solido",
    anyColor: "Altro colore",
    recent: "Recenti",
    sticker: "Adesivo",
    symmetry: "Simmetria",
    colorByNumber: "Colora con i numeri",
    reference: "Riferimento",
    undo: "Annulla",
    redo: "Ripeti",
    reset: "Reset",
    replay: "Replay",
    check: "Controlla",
    save: "Salva",
    fill: "Riempi",
    pencil: "Matita",
    stamp: "Timbro",
    erase: "Cancella",
    on: "ON",
    off: "OFF",
    tool: "Strumento:",
    pattern: "motivo:",
    printOne: "Stampa",
    downloadAll: "Scarica tutto",
    appTitle: "Colora e Crea 🎨",
    appSub: "Pennelli, motivi, adesivi, colora con i numeri e altro!",
  },
};

export default it;
